import { render, staticRenderFns } from "./MarketList.vue?vue&type=template&id=6f4232f8&scoped=true&"
import script from "./MarketList.vue?vue&type=script&lang=js&"
export * from "./MarketList.vue?vue&type=script&lang=js&"
import style0 from "./MarketList.vue?vue&type=style&index=0&id=6f4232f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4232f8",
  null
  
)

export default component.exports